import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Content Grid Item",
}

export default defineBlock("content/content-grid-item", (props) => {
  return (
    <div className="[&_.rich-text-group]:flex [&_.rich-text-group]:flex-col [&_.rich-text-group]:gap-4 md:[&_.rich-text-group]:gap-2 [&_p]:!my-0 [&_p.is-style-body-large]:!font-normal [&_p]:!w-full [&_p]:!px-0 [&_.wysiwyg-text]:!px-0 [&_.wysiwyg-text]:!mt-0 [&_.wysiwyg-text]:!w-full [&_ul]:!gap-2 [&_ol]:!gap-2 [&_li]:!ml-4">
      <InnerBlocks
        allowedBlocks={["#inline"]}
        adminClassName="flex flex-col gap-4"
        template={[["core/paragraph", { placeholder: "Enter your text here..." }]]}
        orientation="vertical"
      />
    </div>
  )
})
